import { Button } from "react-bootstrap";
import Map from "./Map";

function Sponsor(){
    return <div id="sponsor" style={{padding: "3%", alignItems: "center", backgroundImage: "linear-gradient(to bottom, white 30%, pink 70%)"}}>
        <h1 style={{fontFamily: "Inter, sans-serif", fontSize: "calc(20px + 3vw)", textAlign: "center", color: "#FF69B4"}}>Sponsors</h1>
        <br/>
        <Map/>
        <div style={{padding: "5%", textAlign: "center"}}>
            <a href="https://l.facebook.com/l.php?u=https%3A%2F%2Fdocs.google.com%2Fforms%2Fd%2Fe%2F1FAIpQLSfm68i4ucpCvtH4whHXkl4oA62ich7PijsVWi-4b9fwz_JjJQ%2Fviewform%3Ffbclid%3DIwAR1tW4bxDk2wJNSWKoBokJWxrULPyRDMt9snZr3nweH_u_mI6lQ3xEAqrOc&h=AT05alet6rsAZrXQJO8Gd5sfyIq8J5NSqi8aAHRie69k5w7CcDuzaoOEuRB5taTrN1UDiAd7dX2BVmXMcGNGuP0So7-3ZINklUChSaxoL-Kpr1DSQFaQo0VPc_-LoLue7Kz5kQ" target="_blank" rel="noreferrer">
                <Button variant="primary" size="lg" style={{width: "90%"}}><h2>Click me to purchase a card</h2></Button>
            </a>
        </div>
    </div>;
}
export default Sponsor;